import type { Basket } from 'constants/_types/Basket';

export const getBasketItemsInfo = (basketState: Basket | null) => {
  if (!basketState) return { hasSelectedServices: false, selectedServicesNumber: 0 };

  const itemsNumber = Object.values(basketState).reduce((accumulator, { items }) => accumulator + items.length, 0);

  return { hasSelectedServices: !!itemsNumber, selectedServicesNumber: itemsNumber };
};
